import { useState } from "react";
import { Link } from "react-router-dom"; 

export const Gallery = (props) => {
  const [activeFilter, setActiveFilter] = useState("all");

  if (!props.data) return <div className="text-center">Loading...</div>;

  const filteredData = props.data.filter(item => {
    if (activeFilter === "all") return true;
    if (activeFilter === "arge") return item.status === "arge";
    if (activeFilter === "tamamlandi") return item.status === "tamamlandi" || !item.status; 
    return item.category === activeFilter;
  });
  
  const lang = props.lang;

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        
        <div className="section-title">
          <h2>{lang === "tr" ? "Ürünlerimiz" : lang === "ru" ? "ПРОДУКЦИЯ" : "Products"}</h2>
          <div className="heading-underline"></div>
          <p>{lang === "tr" ? "Savunma sanayi ve endüstriyel sistem çözümlerimizi inceleyin." : lang === "ru" ? "Ознакомьтесь с нашими решениями для оборонной промышленности и промышленных систем." : "Explore our defense industry and industrial system solutions."}</p>
        </div>
        
        <div className="filter-menu">
          <button className={`btn-filter ${activeFilter === "all" ? "active" : ""}`} onClick={() => setActiveFilter("all")}>
            {lang === "tr" ? "Tümü" : lang === "ru" ? "Все" : "All"}
          </button>
          <button className={`btn-filter ${activeFilter === "savunma" ? "active" : ""}`} onClick={() => setActiveFilter("savunma")}>
            {lang === "tr" ? "Savunma Sanayi" : lang === "ru" ? "Оборонная промышленность" : "Defense Industry"}
          </button>
          <button className={`btn-filter ${activeFilter === "endustri" ? "active" : ""}`} onClick={() => setActiveFilter("endustri")}>
            {lang === "tr" ? "Endüstriyel Sistemler" : lang === "ru" ? "Промышленные системы" : "Industrial Systems"}
          </button>

          <button className={`btn-filter status-filter arge ${activeFilter === "arge" ? "active" : ""}`} onClick={() => setActiveFilter("arge")}>
            <i className="fa fa-flask" style={{marginRight: "6px"}}></i>
            {lang === "tr" ? "Ar-Ge Aşamasında" : lang === "ru" ? "В разработке" : "In R&D"}
          </button>
          <button className={`btn-filter status-filter completed ${activeFilter === "tamamlandi" ? "active" : ""}`} onClick={() => setActiveFilter("tamamlandi")}>
            <i className="fa fa-check-circle" style={{marginRight: "6px"}}></i>
            {lang === "tr" ? "Tamamlananlar" : lang === "ru" ? "Завершено" : "Completed"}
          </button>
        </div>

        <div className="row">
          <div className="portfolio-items">
            {filteredData.map((d, i) => {
              const isArge = d.status === "arge";

              return (
                <div key={`${d.title}-${i}`} className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                  
                  <Link to={`/${lang}/urun/${d.id}`} className="product-card" style={{ display: "block", cursor: "pointer", textDecoration: "none", marginBottom: "30px" }}>
                    
                    <div style={{ borderRadius: "15px", overflow: "hidden", position: "relative", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(0,0,0,0.08)" }}>
                      
                      {/* ÜRÜN DURUM ROZETİ */}
                      <div style={{
                        position: "absolute",
                        top: "15px",
                        right: "15px",
                        zIndex: "3",
                        padding: "5px 12px",
                        borderRadius: "20px",
                        fontSize: "11px",
                        fontWeight: "800",
                        letterSpacing: "0.5px",
                        backgroundColor: isArge ? "#e5882a" : "#171717", 
                        color: "#EDEDED",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)"
                      }}>
                        {isArge 
                          ? (lang === "tr" ? "AR-GE SÜRECİNDE" : lang === "ru" ? "НИОКР" : "IN R&D") 
                          : (lang === "tr" ? "TAMAMLANDI" : lang === "ru" ? "ЗАВЕРШЕНО" : "COMPLETED")}
                      </div>

                      {/* HOVER EKRANI (Kömür Siyahı Arka Plan, Turuncu Yazı) */}
                      <div className="hover-text" style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%", background: "rgba(23, 23, 23, 0.85)", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", zIndex: "2" }}>
                        <h3 style={{ color: "#e5882a", fontWeight: "700", textShadow: "1px 1px 3px rgba(0,0,0,0.8)", margin: "0 0 10px 0", padding: "0 15px", fontSize: "18px" }}>{d.title}</h3>
                        <p style={{ color: "#EDEDED", border: "1px solid #e5882a", padding: "8px 20px", borderRadius: "30px", display: "inline-block", margin: "0", fontSize: "14px", fontWeight: "600", transition: "all 0.3s ease" }}>
                          {lang === "tr" ? "Detayları İncele" : lang === "ru" ? "Подробнее" : "View Details"}
                        </p>
                      </div>
                      
                      <img 
                        src={`/${encodeURI(d.smallImage)}`} 
                        className="img-responsive" 
                        alt={d.title} 
                        loading="lazy" 
                        style={{ width: "100%", display: "block", backgroundColor: "#ffffff" }} 
                      />

                      {/* YENİ: SABİT ÜRÜN ADI KUTUSU (Fare getirilmeden gözüken) */}
                      {/* Sadece ana başlığı (iki nokta üst üsteden veya tireden önceki kısmı) alarak daha şık durmasını sağlıyoruz */}
                      <div className="persistent-title">
                        {d.title.split(':')[0].split('-')[0].trim()}
                      </div>

                    </div>
                    
                  </Link>
                  
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <style>
        {`
          #portfolio {
            background-color: #EDEDED !important; 
            padding: 100px 0;
          }

          #portfolio .section-title h2 {
            font-family: 'Montserrat', sans-serif !important;
            font-size: 38px !important;
            font-weight: 800 !important;
            color: #171717 !important; 
            text-transform: uppercase;
            margin-bottom: 15px;
          }

          #portfolio .heading-underline {
            width: 70px;
            height: 5px;
            background: #e5882a; 
            margin: 0 auto 20px auto;
            border-radius: 5px;
          }

          #portfolio .section-title p {
            font-size: 16px;
            color: #444444 !important;
            max-width: 600px;
            margin: 0 auto 40px auto;
          }

          .filter-menu {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;
            margin-bottom: 40px;
          }

          .btn-filter {
            background-color: transparent !important;
            color: #171717 !important;
            border: 2px solid #171717 !important;
            padding: 8px 20px !important;
            border-radius: 30px !important;
            font-family: 'Inter', sans-serif !important;
            font-size: 14px;
            font-weight: 600 !important;
            cursor: pointer !important;
            transition: all 0.3s ease !important;
          }

          .btn-filter:hover,
          .btn-filter.active {
            background-color: #171717 !important;
            color: #e5882a !important;
            box-shadow: 0 4px 15px rgba(23, 23, 23, 0.3) !important;
            border-color: #171717 !important;
          }

          .btn-filter.status-filter.arge:hover,
          .btn-filter.status-filter.arge.active {
            color: #e5882a !important; 
          }

          .btn-filter.status-filter.completed:hover,
          .btn-filter.status-filter.completed.active {
            color: #EDEDED !important; 
          }
        `}
      </style>
    </div>
  );
};